/**
 * Media Link Banner
 *
 * Sizes the watermark text so it exactly fills the available width between the
 * side insets. The font-size scales linearly from a measured baseline, capped
 * so it never grows too large or shrinks below a legible minimum.
 *
 * @see MDS-562
 */

const ROOT_SELECTOR = "[data-cirrus-media-link-banner]";
const MAX_FONT = 160;
const MIN_FONT = 24;

/**
 * Size a single watermark element to fill its wrapper width.
 *
 * @param {HTMLElement} el The watermark text element.
 */
const fitWatermark = (el) => {
	const wrapper = el.parentElement;
	if (!wrapper) {
		return;
	}

	const available = wrapper.clientWidth;
	if (available <= 0) {
		return;
	}

	el.style.fontSize = `${MAX_FONT}px`;
	const measured = el.scrollWidth;
	if (measured <= 0) {
		return;
	}

	const target = Math.max(MIN_FONT, Math.min(MAX_FONT, (available / measured) * MAX_FONT));
	el.style.fontSize = `${target}px`;
};

/**
 * Initialize every banner found in the document.
 */
const init = () => {
	const roots = document.querySelectorAll(ROOT_SELECTOR);

	roots.forEach((root) => {
		const watermark = root.querySelector("[data-watermark-text]");
		if (!watermark) {
			return;
		}

		const run = () => fitWatermark(watermark);
		run();

		if ("ResizeObserver" in window) {
			const observer = new ResizeObserver(run);
			observer.observe(root);
		} else {
			window.addEventListener("resize", run);
		}

		window.addEventListener("load", run);
	});
};

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}
